import axios from 'axios';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import FileSaver from 'file-saver';
import {
    champsAnnouncementState,
    champsAnnouncementMutations,
    champsAnnouncementActions,
    champsAnnouncementGetters,
} from './champsAnnouncement';

import {
    champsCustomEmailState,
    champsCustomEmailMutations,
    champsCustomEmailActions,
    champsCustomEmailGetters,
} from './champsCustomEmailGroup';

import { getAxiosCancelTokenSource } from '@/app.utils';

const champsPageState = () => {
    return {
        ...champsAnnouncementState,
        ...champsCustomEmailState,
        baseURL: process.env.VUE_APP_BASE_URL,
        selectedComponentForLoader: null,
        forumCategoryList: null,
        nextBoardMeetingEvent: null,
    };
};

const champsPageMutations = {
    ...champsAnnouncementMutations,
    ...champsCustomEmailMutations,
    [storeMutation.setComponentForInlineLoader]: (state, componentDetail) => {
        if (
            componentDetail &&
            componentDetail.hasOwnProperty('title') &&
            componentDetail.hasOwnProperty('componentName') &&
            componentDetail.hasOwnProperty('componentProps')
        ) {
            state.selectedComponentForLoader = { ...componentDetail };
        } else {
            state.selectedComponentForLoader = null;
        }
    },
    [storeMutation.resetInlineLoader]: (state) => {
        state.selectedComponentForLoader = null;
    },
    [storeMutation.setForumCategory]: (state, data) => {
        state.forumCategoryList = data || null;
    },
    [storeMutation.setNextBoardMeetingEvent]: (state, data) => {
        state.nextBoardMeetingEvent = data;
    },
};

const champsPageActions = {
    ...champsAnnouncementActions,
    ...champsCustomEmailActions,

    [storeAction.getChapterEventsAttendees]: wrapAction(
        storeAction.getChapterEventsAttendees,
        ({ state, commit }, communityId) => {
            //preparing cancellable axios request
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getChapterEventsAttendees,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, {
                root: true,
            });

            //TODO: using mock for now to test when Champs Page is set to get the actual
            return axios({
                url: `${state.baseURL}events/api/events/eventAttendees/${communityId}`,

                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getChapterEventsAttendees, { root: true });
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getChapterHealthPoints]: wrapAction(
        storeAction.getChapterHealthPoints,
        ({ state, commit }, communityId) => {
            //preparing cancellable axios request
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getChapterHealthPoints,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, {
                root: true,
            });

            //TODO: using mock for now to test when Champs Page is set to get the actual
            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/chapterHealthRecord/${communityId}`,

                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getChapterHealthPoints, { root: true });
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getChapterElectedOfficers]: wrapAction(
        storeAction.getChapterElectedOfficers,
        ({ state, commit }, communityId) => {
            //resetting the state to null before making a new call

            //preparing cancellable axios request
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getChapterElectedOfficers,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, {
                root: true,
            });

            //TODO: using mock for now to test when Champs Page is set to get the actual
            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/electedOfficerEngagement/${communityId}`,

                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getChapterElectedOfficers, { root: true });
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getChapterHealthRating]: wrapAction(
        storeAction.getChapterHealthRating,
        ({ state, commit }, communityId) => {
            //resetting the state to null before making a new call

            //preparing cancellable axios request
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getChapterHealthRating,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, {
                root: true,
            });

            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/regionChapterHealthRating/${communityId}`,

                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getChapterHealthRating, { root: true });
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getChapterAgeDemographics]: wrapAction(
        storeAction.getChapterAgeDemographics,
        ({ state, commit }, communityId) => {
            //resetting the state to null before making a new call

            //preparing cancellable axios request
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getChapterAgeDemographics,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, {
                root: true,
            });

            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/chapterPerformanceAgeDemographic/${communityId}`,

                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getChapterAgeDemographics, { root: true });
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getChapterGenderDemographics]: wrapAction(
        storeAction.getChapterGenderDemographics,
        ({ state, commit }, communityId) => {
            //resetting the state to null before making a new call

            //preparing cancellable axios request
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getChapterGenderDemographics,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, {
                root: true,
            });

            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/chapterPerformanceGenderDemographic/${communityId}`,

                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getChapterEventsDownloadExcelFile]: ({ state }, communityId) => {
        return axios({
            url: `${state.baseURL}events/api/events/downloadEventAttendees/${communityId}`,
            headers: getBasicHeaders(),
            data: communityId,
            method: 'GET',
            responseType: 'arraybuffer',
        })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'octet/stream' });
                const fileName = `Event Attendees.xlsx`;
                FileSaver.saveAs(blob, fileName);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getForumCategory]: wrapAction(storeAction.getForumCategory, ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/getForumCategory`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setForumCategory, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getNextBoardMeetingEvent]: async ({ state, commit }, chapterId) => {
        const promise = new Promise((resolve) => {
            axios({
                url: `${state.baseURL}events/api/events/next-board-meeting-event/${chapterId}/chapter`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setNextBoardMeetingEvent, response.data);
                    resolve(response.data);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
        const result = await promise;
        return result;
    },
};

const champsPageGetters = {
    ...champsAnnouncementGetters,
    ...champsCustomEmailGetters,
    [storeGetters.activeComponentPropsForInlineLoader]: state => state.selectedComponentForLoader,
    [storeGetters.forumCategoryList]: state => state.forumCategoryList,
    [storeGetters.nextBoardMeetingEvent]: state => state.nextBoardMeetingEvent,
};

export default {
    namespaced: true,
    state: {
        initialState: champsPageState(),
        ...champsPageState(),
    },
    mutations: { ...champsPageMutations },
    actions: { ...champsPageActions },
    getters: { ...champsPageGetters },
};
